import { SimuladorLanding } from './SimuladorLanding';
import type { SimuladorLandingConfig } from './SimuladorLanding';
import type { FreeLimits } from '../types';

const config: SimuladorLandingConfig = {
  slug: 'simulador-libertadores-2026',
  routeId: 'sim-libertadores',
  competitionExternalId: 13,
  seoTitle: 'Simulador Copa Libertadores 2026 — Monte seu Bracket Gratis | Bolao Elite',
  seoDescription:
    'Simule a Copa Libertadores da America 2026. Monte o bracket, escolha os classificados de cada grupo e simule o mata-mata ate a grande final em Buenos Aires.',
  seoKeywords:
    'simulador libertadores 2026, simulador copa libertadores, bracket libertadores, chaveamento libertadores 2026, simulador libertadores gratis',
  canonical: 'https://bolaoelite.com.br/simulador-libertadores-2026',
  heroTitle: 'Simulador Libertadores 2026',
  heroSubtitle:
    'Monte o bracket da Copa Libertadores da America 2026. Escolha os classificados dos grupos e simule cada fase ate a final.',
  accentFrom: '#1b5e20',
  accentTo: '#2e7d32',
  formatDescription: '32 clubes · 8 grupos de 4 · Mata-mata ida e volta · Final em jogo unico',
  bolaoRouteId: 'pool-libertadores',
  bolaoLabel: 'Criar Bolao da Libertadores',
  about: [
    'A Copa Libertadores da America 2026 e a principal competicao de clubes da America do Sul, organizada pela CONMEBOL. Reune os melhores clubes do continente em uma disputa que comeca na fase de grupos e culmina na grande final.',
    'A competicao conta com 32 clubes divididos em 8 grupos de 4 times. Os dois primeiros de cada grupo avancam para as oitavas de final, iniciando a fase eliminatoria.',
    'O mata-mata e disputado em jogos de ida e volta (exceto a final), proporcionando confrontos emocionantes com a possibilidade de viradas dramaticas no jogo de volta.',
    'A final da Libertadores 2026 sera disputada em jogo unico em sede a ser definida pela CONMEBOL, seguindo o formato adotado desde 2019.',
  ],
  facts: [
    'Principal competicao de clubes da America do Sul',
    '32 clubes de 10 paises sul-americanos',
    '8 grupos de 4 times na fase de grupos',
    'Mata-mata em jogos de ida e volta',
    'Final em jogo unico em sede neutra',
    'Campeao garante vaga no Mundial de Clubes',
    'Clubes brasileiros sao os maiores vencedores',
    'Trofeu mais cobiçado do futebol sul-americano',
  ],
  rules: [
    {
      title: 'Formato da Fase de Grupos',
      items: [
        '32 clubes divididos em 8 grupos de 4 times (Grupo A ao Grupo H)',
        'Cada clube joga 6 partidas (3 em casa, 3 fora) — todos contra todos em turno e returno',
        'Vitoria = 3 pontos, Empate = 1 ponto, Derrota = 0 pontos',
        'Os 2 primeiros de cada grupo avancam para as oitavas de final (16 times)',
      ],
    },
    {
      title: 'Criterios de Desempate nos Grupos',
      items: [
        'Maior numero de pontos obtidos',
        'Saldo de gols',
        'Maior numero de gols marcados',
        'Confronto direto (pontos, saldo e gols)',
        'Sorteio da CONMEBOL (ultimo recurso)',
      ],
    },
    {
      title: 'Fase Eliminatoria (Mata-Mata)',
      items: [
        'Oitavas de final: 8 confrontos (ida e volta)',
        'Quartas de final: 4 confrontos (ida e volta)',
        'Semifinais: 2 confrontos (ida e volta)',
        'Final: jogo unico em sede neutra definida pela CONMEBOL',
      ],
    },
    {
      title: 'Regras do Mata-Mata (Ida e Volta)',
      items: [
        'Avanca o time com maior placar agregado (soma dos 2 jogos)',
        'Regra do gol fora de casa NAO esta mais em vigor desde 2022',
        'Em caso de empate no agregado: prorrogacao de 30 minutos no jogo de volta',
        'Se persistir o empate: disputa de penaltis',
        'Na final (jogo unico): empate no tempo regulamentar leva a prorrogacao e penaltis',
      ],
    },
  ],
  faqs: [
    {
      question: 'Como funciona o simulador da Libertadores?',
      answer: 'Voce escolhe os 2 classificados de cada um dos 8 grupos e depois simula cada confronto do mata-mata (oitavas, quartas, semifinais e final) ate descobrir o campeao.',
    },
    {
      question: 'O gol fora de casa ainda vale na Libertadores?',
      answer: 'Nao. Desde 2022 a CONMEBOL aboliu a regra do gol fora de casa. Em caso de empate no placar agregado, a decisao vai para prorrogacao e penaltis.',
    },
    {
      question: 'A final e em jogo unico ou ida e volta?',
      answer: 'Desde 2019, a final da Libertadores e disputada em jogo unico, em sede neutra definida pela CONMEBOL.',
    },
    {
      question: 'O simulador e gratuito?',
      answer: 'Sim! O simulador da Libertadores 2026 e 100% gratuito, sem cadastro obrigatorio. Simule quantas vezes quiser.',
    },
    {
      question: 'Posso criar um bolao da Libertadores?',
      answer: (limits: FreeLimits) =>
        `Sim! O Bolao Elite tem plano gratuito e Premium. No gratuito voce cria ${limits.maxPrivatePoolsCreated} bolao privado e participa de ate ${limits.maxPrivatePoolsJoined} como convidado. O Premium desbloqueia boloes e participantes ilimitados.`,
    },
    {
      question: 'Quantos clubes brasileiros participam da Libertadores?',
      answer: 'O Brasil e o pais com mais representantes, geralmente com 6 a 7 clubes na fase de grupos, entre classificados do Brasileirao e da Copa do Brasil.',
    },
  ],
  jsonLd: {
    '@context': 'https://schema.org',
    '@type': 'SportsEvent',
    name: 'Copa Libertadores da America 2026',
    startDate: '2026-02-01',
    location: {
      '@type': 'Place',
      name: 'America do Sul',
    },
    organizer: {
      '@type': 'Organization',
      name: 'CONMEBOL',
    },
  },
};

export default function LandingSimuladorLibertadores() {
  return <SimuladorLanding config={config} />;
}
